module.exports = __webpack_public_path__ + "static/media/Yumi Yang.c1d376c7.png";